<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="40" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <ElInput v-model.trim="keyword" :placeholder="placeholder" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>

        <ElFormItem label="媒体">
          <ThrottleSelector
            v-model="mediaId"
            :list="mediaData"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <el-button type="primary" @click="$emit('on-set')">新建授权应用</el-button>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import ThrottleSelector from '@/components/throttle-select/index.vue'
export default {
  name: 'developerConfigFilter',
  components: { ThrottleSelector },
  props: {
    mediaData: {
      type: Array
    },
    placeholder: {
      type: String
    }
  },
  methods: {
    sendEvent() {
      const params = {
        mediaId: this.mediaId === '' ? undefined : this.mediaId
      }
      this.$emit('on-search', params)
    },
    search() {
      let params = {
        mediaId: this.mediaId === -1 ? undefined : this.mediaId
      }
      params = Object.assign(params, { keyword: this.keyword === '' ? undefined : this.keyword })
      this.$emit('on-search', params)
    }
  },
  data() {
    return {
      keyword: '',
      mediaId: ''
    }
  },
  created() {}
}
</script>
